// ================================================================
// State — وضعیت مرکزی اپ
// ================================================================
// تمام nodeها، connectionها و وضعیت‌های مشترک اینجا نگه داشته می‌شن.
// تغییرات state یه event منتشر می‌کنن تا UI خودش رو بازخوانی کنه.

import { events, EVENTS } from './events.js';
import { storage } from './storage.js';

class State {
  constructor() {
    this.nodes = [];          // [{id, type, x, y, config}]
    this.connections = [];    // [{fromId, toId}]
    this.nextId = 1;

    // وضعیت موقت UI (در localStorage ذخیره نمی‌شه)
    this.wasDragged = false;
    this.selectedNodeId = null;
    this.selectedConnection = null;
  }

  // -------------------- Node ها --------------------
  addNode(type, x, y) {
    const node = {
      id: this.nextId++,
      type,
      x,
      y,
      config: {}
    };
    this.nodes.push(node);
    events.emit(EVENTS.NODE_ADDED, node);
    this._persist();
    return node;
  }

  removeNode(id) {
    const idx = this.nodes.findIndex(n => n.id === id);
    if (idx === -1) return;
    this.nodes.splice(idx, 1);
    // اتصال‌های مربوط رو هم پاک کن
    this.connections = this.connections.filter(
      c => c.fromId !== id && c.toId !== id
    );
    events.emit(EVENTS.NODE_REMOVED, id);
    this._persist();
  }

  moveNode(id, x, y) {
    const node = this.getNode(id);
    if (!node) return;
    node.x = x;
    node.y = y;
    events.emit(EVENTS.NODE_MOVED, node);
    this._persist();
  }

  updateNodeConfig(id, config) {
    const node = this.getNode(id);
    if (!node) return;
    node.config = { ...node.config, ...config };
    events.emit(EVENTS.NODE_CONFIG_UPDATED, node);
    this._persist();
  }

  getNode(id) {
    return this.nodes.find(n => n.id === id);
  }

  // -------------------- اتصالات --------------------
  addConnection(fromId, toId) {
    // جلوگیری از duplicate
    const exists = this.connections.some(
      c => c.fromId === fromId && c.toId === toId
    );
    if (exists) return;
    const conn = { fromId, toId };
    this.connections.push(conn);
    events.emit(EVENTS.CONNECTION_ADDED, conn);
    this._persist();
  }

  removeConnection(fromId, toId) {
    this.connections = this.connections.filter(
      c => !(c.fromId === fromId && c.toId === toId)
    );
    if (this.isConnectionSelected(fromId, toId)) {
      this.selectedConnection = null;
    }
    events.emit(EVENTS.CONNECTION_REMOVED, { fromId, toId });
    this._persist();
  }

  // -------------------- انتخاب اتصال --------------------
  selectConnection(fromId, toId) {
    this.selectedConnection = { fromId, toId };
    events.emit(EVENTS.CONNECTION_SELECTED, this.selectedConnection);
  }

  clearSelection() {
    if (!this.selectedConnection) return;
    this.selectedConnection = null;
    events.emit(EVENTS.CONNECTION_SELECTED, null);
  }

  isConnectionSelected(fromId, toId) {
    const c = this.selectedConnection;
    return !!c && c.fromId === fromId && c.toId === toId;
  }

  // -------------------- بارگذاری snapshot یک سناریو --------------------
  // محتوای canvas را با دادهٔ یک شرکت جایگزین می‌کند (بدون ذخیره‌ی دوباره)
  loadSnapshot(data) {
    this.nodes = Array.isArray(data?.nodes) ? data.nodes : [];
    this.connections = Array.isArray(data?.connections) ? data.connections : [];
    this.nextId = typeof data?.nextId === 'number'
      ? data.nextId
      : this.nodes.reduce((max, n) => Math.max(max, (n.id || 0) + 1), 1);
    this.selectedNodeId = null;
    this.selectedConnection = null;
    events.emit(EVENTS.SCENARIO_LOADED);
  }

  // -------------------- reset --------------------
  reset() {
    this.nodes = [];
    this.connections = [];
    this.nextId = 1;
    this.addNode('start', 280, 240);
  }

  // -------------------- ذخیره خودکار --------------------
  _persist() {
    storage.save({
      nodes: this.nodes,
      connections: this.connections,
      nextId: this.nextId
    });
    events.emit(EVENTS.STATE_CHANGED);
  }
}

// نمونه singleton
export const state = new State();
